/**
 * Keep "All" plus only leagues that currently have at least one event in the
 * odds feed. Sports nav stays separate — this only trims league chips.
 */
export const filterLeagueOptionsWithGames = (catalogOptions = [], games = []) => {
  const allOption = { title: "All", key: "All" };
  const list = Array.isArray(catalogOptions) ? catalogOptions : [];
  const gameList = Array.isArray(games) ? games : [];

  const keysWithGames = new Set(
    gameList
      .map((game) => game?.sport_key)
      .filter((key) => typeof key === "string" && key.length > 0)
  );

  const leagues = list.filter((option) => {
    const key = option?.key || option?.title;
    if (!key || key === "All") return false;
    return keysWithGames.has(key);
  });

  // Preserve catalog order; drop empty leagues.
  return [allOption, ...leagues];
};

/**
 * Favorites board filter: only show league chips that have at least one
 * starred match present in the current odds feed (plus All).
 */
export const filterLeagueOptionsForFavorites = (
  catalogOptions = [],
  favGames = [],
  liveGames = []
) => {
  const favIds = new Set(
    (Array.isArray(favGames) ? favGames : [])
      .map((game) => game?.id)
      .filter(Boolean)
  );
  const playable = (Array.isArray(liveGames) ? liveGames : []).filter((game) =>
    favIds.has(game?.id)
  );
  return filterLeagueOptionsWithGames(catalogOptions, playable);
};

export const isLeagueOptionValid = (navOptions = [], selectedOption) => {
  const selectedKey = selectedOption?.key || selectedOption?.title || "All";
  if (selectedKey === "All") return true;
  return navOptions.some((option) => option.key === selectedKey);
};
